import { motion } from "framer-motion";
import {
  GraduationCap,
  PartyPopper,
  HeartPulse,
  Palette,
  Heart,
  Gift,
  Users,
  Check,
  Sparkles,
} from "lucide-react";
import { IMPACT } from "./data";

const ICONS = { GraduationCap, PartyPopper, HeartPulse, Palette, Heart, Gift, Users };

export const Impact = () => (
  <section id="impact" data-testid="impact-section" className="relative py-24 lg:py-32 bg-[#FAFAFA]">
    <div className="neon-hairline absolute top-0 left-0 right-0" />
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="max-w-2xl"
      >
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-cyan-500">03 · The Impact</p>
        <h2 className="mt-4 text-3xl md:text-5xl font-black tracking-tight text-slate-900 uppercase">
          Where your money goes
        </h2>
      </motion.div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {IMPACT.map((col, i) => {
          const Icon = ICONS[col.icon];
          return (
            <motion.div
              key={col.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              data-testid={`impact-column-${col.title.toLowerCase().replace(/\s/g, "-")}`}
              className="relative bg-white rounded-2xl p-8 border border-slate-200 hover:-translate-y-1.5 transition-transform duration-300"
              style={{ boxShadow: `0 8px 30px rgba(0,0,0,0.04)` }}
            >
              <span className="absolute top-6 right-7 text-4xl font-black text-slate-100 select-none">
                {col.num}
              </span>
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center"
                style={{ backgroundColor: `${col.accent}14`, border: `1px solid ${col.accent}`, boxShadow: `0 0 18px ${col.accent}33` }}
              >
                <Icon size={26} style={{ color: col.accent }} />
              </div>
              <h3 className="mt-6 text-lg sm:text-xl font-black uppercase tracking-wide text-slate-900 pr-10">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {col.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm font-medium text-slate-600">
                    <Check size={15} className="mt-0.5 shrink-0" style={{ color: col.accent }} />
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          );
        })}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.2 }}
        data-testid="impact-closing-note"
        className="mt-12 text-center text-base md:text-lg font-bold text-slate-700 flex items-center justify-center gap-2"
      >
        <Sparkles size={18} className="text-pink-500" />
        …and much more thanks to your support!
        <Sparkles size={18} className="text-cyan-500" />
      </motion.p>
    </div>
  </section>
);
